import { useState } from 'react';
import { CompetitionClassTypeClient, CompetitionClassTypeDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useCompetitionClassTypeApi = () => {
    const apiClient = new CompetitionClassTypeClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: CompetitionClassTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createCompetitionClassType(data);
        } catch (err: any) {
            setError(err.message || 'Error creating CompetitionClassType');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: CompetitionClassTypeDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateCompetitionClassType(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating CompetitionClassType');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getCompetitionClassTypeById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching CompetitionClassType');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchCompetitionClassTypes(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching CompetitionClassTypes');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteCompetitionClassType(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting CompetitionClassType');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};